import { Component, Input } from '@angular/core';
import { AdPlacementRoadOccupationFormValue } from '../../forms/ad-placement-road-occupation.form';
import { DatePipe } from '@angular/common';
import { LabelComponent } from '../../../../../../../../common/label/label.component';
import {
  ParcelsPreviewComponent
} from '../../../../../common/components/parcels/parcels-preview/parcels-preview.component';
import { last } from 'rxjs';

@Component({
  selector: 'app-ad-placement-occupation-preview',
  standalone: true,
  imports: [
    DatePipe,
    LabelComponent,
    ParcelsPreviewComponent
  ],
  templateUrl: './ad-placement-occupation-preview.component.html'
})
export class AdPlacementOccupationPreviewComponent {

  @Input()
  public occupation: AdPlacementRoadOccupationFormValue | undefined;
  protected readonly last = last;
}
